import {MicState} from '@AiChat/hooks/useAudioLimit';
import {isUserLoggedIn} from '@Libraries/user.library';
import type {RefObject} from 'react';

const micLoginCallbacks = new Map<string, () => void>();

export const registerMicLoginCallback = (id: string, fn: (() => void) | undefined): void => {
  if (fn) {
    micLoginCallbacks.set(id, fn);
  } else {
    micLoginCallbacks.delete(id);
  }
};

export const unregisterMicLoginCallback = (id: string): void => {
  micLoginCallbacks.delete(id);
};

export const getMicLoginCallback = (id: string): (() => void) | undefined => {
  return micLoginCallbacks.get(id);
};

const startRecordingRefs = new Map<string, RefObject<() => void>>();

export const registerStartRecording = (id: string, ref: RefObject<() => void>): void => {
  startRecordingRefs.set(id, ref);
};

export const unregisterStartRecording = (id: string): void => {
  startRecordingRefs.delete(id);
};

export const callStartRecording = (id: string): void => {
  startRecordingRefs.get(id)?.current();
};

export const getMicTooltip = (micState: MicState, permissionDenied = false): string => {
  if (permissionDenied) {
    return window.i18next.t('pmwjs_mic_permission_denied');
  }

  if (!isUserLoggedIn()) {
    return window.i18next.t('pmwjs_record_audio');
  }

  switch (micState) {
    case MicState.LOADING:
      return window.i18next.t('pmwjs_checking_audio_limit');
    case MicState.ERROR:
      return window.i18next.t('pmwjs_unable_to_check_limit');
    case MicState.LIMITED:
      return window.i18next.t('pmwjs_daily_limit_reached');
    default:
      return window.i18next.t('pmwjs_record_audio');
  }
};
